import moment from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import {
  BLACK_FRIDAY_SLUG,
  BLACK_FRIDAY_PARTICIPATION_SLUG,
  SUMO_DAY_SLUG,
  SUMO_DAY_PARTICIPATION_SLUG,
  LAST_CALL_SLUG,
  LAST_CALL_PARTICIPATION_SLUG,
  BLACK_FRIDAY_LAST_CALL_SLUG,
  BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
} from '@/constants/global';

moment.extend(isBetween);

export default {
  computed: {
    now() {
      const now = new Date();
      const imitationDate = (
        this.$store.state.session?.session?.preview_campaign
        && this.$store.state.session.session.preview_campaign.imitation_date
      );
      if (imitationDate) {
        return new Date(imitationDate);
      }
      return now;
    },
    campaigns() {
      if (this.$store && this.$store.getters) {
        return this.$store.getters.campaigns || [];
      }
      return [];
    },
    showBlackFridayRoadblock() {
      const showBlackFridayRoadBlock = process.env.SHOW_BLACK_FRIDAY_ROADBLOCK;

      // hide it no matter we are in the corresponding dates
      if (!showBlackFridayRoadBlock) { return false; }

      const now = moment(this.now);
      const startDate = moment('2021-09-15T17:00:00.000-06:00');
      const endDate = moment('2021-11-17T12:00:00.000-06:00');

      return now.isBetween(startDate, endDate, null, '[)');
    },
    showBlackFridayEmailRoadblock() {
      const now = this.$route.query.show_bf_roadblock
        ? moment('2021-11-24T17:00-06:00') : moment(new Date());

      const startDate = moment('2021-11-21T17:00:00.000-06:00');
      const endDate = moment('2021-11-30T12:00:00.000-06:00');

      return now.isBetween(startDate, endDate, null, '[)');
    },
  },
  methods: {
    isCampaignActive(slug) {
      const { campaigns } = this.$store.getters;

      return (campaigns || []).includes(slug);
    },
    isBlackFriday(deal) {
      const isCampaignActive = this.campaigns.includes(BLACK_FRIDAY_SLUG);
      return isCampaignActive && !!deal?.participation?.includes(BLACK_FRIDAY_PARTICIPATION_SLUG);
    },
    isSumoDay(deal) {
      const isCampaignActive = this.campaigns.includes(SUMO_DAY_SLUG);
      return isCampaignActive && !!deal?.participation?.includes(SUMO_DAY_PARTICIPATION_SLUG);
    },
    isBlackFridayLastCall(deal) {
      return deal.buy_button?.is_last_call === true
        && this.isParticipatingAndActive(
          deal,
          BLACK_FRIDAY_LAST_CALL_SLUG,
          BLACK_FRIDAY_LAST_CALL_PARTICIPATION_SLUG,
        );
    },
    isComingSoon(deal) {
      return deal.buy_button?.is_coming_soon === true;
    },
    isParticipatingAndActive(deal, campaignSlug, participationSlug) {
      const isCampaignActive = this.campaigns.includes(campaignSlug);
      return isCampaignActive && deal.participation?.includes(participationSlug);
    },
    isLastCall(deal) {
      return deal.buy_button?.is_last_call === true
        && this.isParticipatingAndActive(
          deal,
          LAST_CALL_SLUG,
          LAST_CALL_PARTICIPATION_SLUG,
        );
    },
    isLimitedTimeSale(deal) {
      return this.isLastCall(deal) || this.isBlackFridayLastCall(deal);
    },
    hasBanner(deal) {
      return (
        deal.browse_deal_status === 'expired'
    || (deal.shows_codes_remaining && deal.codes_remaining > 0)
    || (
      deal.browse_deal_status === 'current'
        && deal.dates
        && deal.dates.end_date
        && deal.has_started
        && deal.active_timer
    )
    || this.isComingSoon(deal)
      );
    },
    isNewDeal(deal) {
      if (deal.has_ended || !deal.dates?.start_date) {
        return false;
      }

      const now = moment(new Date());
      const startDate = moment(deal.dates.start_date);
      const cutoff = startDate.add(1, 'day');

      return now.isBetween(startDate, cutoff, null, '[)');
    },
  },
};
